<template>
    <nav class="flex w-full bg-gradient-to-b from-gray-900 to-black justify-center border-t border-white">
        <div class="max-w-md py-10 grid lg:grid-cols-2">
            <router-link to="/"><img src="../assets/logo.png" class="w-32 h-auto lg:mr-8" /></router-link>
            <ul class="text-center text-slate-300 space-y-2 font-londrina lg:text-left"> 
                <li class="transition ease-in-out duration-150 cursor-pointer hover:text-white hover:scale-105"><RouterLink to="/">Home</RouterLink></li>
                <li class="transition ease-in-out duration-150 cursor-pointer hover:text-white hover:scale-105"><RouterLink to="/pricing">Pricing</RouterLink></li>
                <li class="transition ease-in-out duration-150 cursor-pointer hover:text-white hover:scale-105"><RouterLink to="/signup">Sign Up</RouterLink></li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: "AppFooter",
};
</script>